import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b734d45"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "quantity-break" }
const _hoisted_2 = { class: "quantity-break__title" }
const _hoisted_3 = { class: "quantity-break__quantity-breaks" }
const _hoisted_4 = { class: "qty-break" }
const _hoisted_5 = {
  key: 0,
  class: "value"
}
const _hoisted_6 = {
  key: 1,
  class: "value"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "quantity-break__title-wrapper",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleQuantityBreaks && _ctx.toggleQuantityBreaks(...args)))
    }, [
      _createElementVNode("h5", _hoisted_2, _toDisplayString(_ctx.$t("QuantityBreak.Title")), 1)
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.group, (quantityBreak) => {
        return (_openBlock(), _createElementBlock("div", {
          key: quantityBreak.qtyBreak,
          class: "break"
        }, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(quantityBreak.qtyBreak) + " " + _toDisplayString(_ctx.productUnitType), 1),
          (_ctx.showPricesAsB2b)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(quantityBreak.value), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(quantityBreak.valueIncVat), 1))
        ]))
      }), 128))
    ], 512), [
      [_vShow, _ctx.showQuantityBreaks || !_ctx.hidePrices]
    ])
  ]))
}